import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { activeSnack } from './common';
import { get, put, post } from '../http';

// --- API THUNKS START ---
// Example thunk for Automation (replace/add real thunks as needed)
export const getAllAutomationList = createAsyncThunk('automation/all', async ({ credentials }) => {
  try {
    const URL = `/automation/admin/all?page=${credentials?.page || 1}&limit=${
      credentials?.limit || 25
    }&from=${credentials?.date?.from || ''}&to=${credentials?.date?.to || ''}&search=${
      credentials?.search || ''
    }`;

    const response = await post(URL, credentials?.state || {});

    if (response) {
      return {
        automation: response?.automations || response?.data || [],
        total: response?.total || 0,
        page: response?.page || 1,
      };
    }
    return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    credentials?.dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});

export const createAutomation = createAsyncThunk('automation/create', async ({ credentials }) => {
  try {
    const response = await post('/automation/admin/new', credentials.body);
    if (response) {
      credentials?.dispatch(activeSnack({ type: 'success', message: 'Rule Created Successfully' }));
      credentials?.navigate();
      return response;
    }
    return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    console.log('error', error);

    credentials?.dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});

export const getAutomationDetails = createAsyncThunk(
  'automation/details',
  async ({ credentials }) => {
    try {
      const response = await get(`/automation/admin/${credentials.id}`);
      if (response) {
        return response;
      }
      return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      credentials?.dispatch(
        activeSnack({ type: 'error', message: error?.response?.data?.message })
      );
      throw error?.response?.data?.message;
    }
  }
);

export const updateAutomation = createAsyncThunk('automation/update', async ({ credentials }) => {
  try {
    const response = await put(`/automation/admin/${credentials.id}`, credentials.body);
    if (response) {
      credentials?.dispatch(
        activeSnack({ type: 'success', message: 'Automation Updated Successfully' })
      );
      return response;
    }
    return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    credentials?.dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});

export const updateAutomationStatus = createAsyncThunk(
  'automation/status',
  async ({ credentials }) => {
    const response = await post(`/automation/admin/active/${credentials.id}`);
    return response;
  }
);

// rule template
export const getAllRuleTemplateList = createAsyncThunk(
  'automation/rule-template/all',
  async ({ credentials }) => {
    const URL = `/automation-rule-template/admin/all?page=${credentials?.page || 1}&limit=${
      credentials?.limit || 25
    }&from=${credentials?.date?.from || ''}&to=${credentials?.date?.to || ''}&search=${
      credentials?.search || ''
    }`;
    const response = await post(URL, credentials?.state || {});
    return response;
  }
);

export const createRuleTemplate = createAsyncThunk(
  'automation/rule-template/create',
  async ({ credentials }) => {
    try {
      const response = await post('/automation-rule-template/admin/new', credentials.body);
      if (response) {
        credentials?.dispatch(
          activeSnack({ type: 'success', message: 'Rule Created Successfully' })
        );
        credentials?.handleCloseModal();
        credentials?.setFinalRuleTemplateId?.(response?._id);
        credentials?.redirect();
        return response;
      }
      return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      credentials?.dispatch(
        activeSnack({ type: 'error', message: error?.response?.data?.message })
      );
      throw error?.response?.data?.message;
    }
  }
);

export const getRuleTemplateDetails = createAsyncThunk(
  'automation/rule-template/details',
  async ({ credentials }) => {
    const response = await get(`/automation-rule-template/admin/${credentials.id}`);
    return response;
  }
);

export const updateRuleTemplate = createAsyncThunk(
  'automation/rule-template/update',
  async ({ credentials }) => {
    try {
      const response = await put(
        `/automation-rule-template/admin/${credentials.id}`,
        credentials.body
      );
      if (response) {
        credentials?.dispatch(
          activeSnack({ type: 'success', message: 'Rule Updated Successfully' })
        );
        credentials?.handleCloseModal();
        return response;
      }
      return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      credentials?.dispatch(
        activeSnack({ type: 'error', message: error?.response?.data?.message })
      );
      throw error?.response?.data?.message;
    }
  }
);

export const updateRuleTemplateStatus = createAsyncThunk(
  'automation/rule-template/status',
  async ({ credentials }) => {
    const response = await post(`/automation-rule-template/admin/active/${credentials.id}`);
    credentials.onCloseModal?.();
    return response;
  }
);

// execute the finding
export const executeAutomationFindings = createAsyncThunk(
  'automation/findings/execute',
  async ({ credentials }) => {
    const response = await post(`/automation-findings/admin/execute/${credentials.id}`);
    return response;
  }
);

// reject the finding
export const rejectAutomationFindings = createAsyncThunk(
  'automation/findings/reject',
  async ({ credentials }) => {
    const response = await post(`/automation-findings/admin/reject/${credentials.id}`);
    return response;
  }
);

// execute the finding (advertiser)
export const executeAutomationFindingsAdvertiser = createAsyncThunk(
  'automation/findings/execute-advertiser',
  async ({ credentials }) => {
    try {
      const response = await post(`/automation-findings/advertiser/execute/${credentials.id}`);
      if (response) {
        credentials?.dispatch(
          activeSnack({ type: 'success', message: 'Finding executed successfully' })
        );
        return response;
      }
      return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      credentials?.dispatch(
        activeSnack({ type: 'error', message: error?.response?.data?.message })
      );
      throw error?.response?.data?.message;
    }
  }
);

// reject the finding (advertiser)
export const rejectAutomationFindingsAdvertiser = createAsyncThunk(
  'automation/findings/reject-advertiser',
  async ({ credentials }) => {
    try {
      const response = await post(`/automation-findings/advertiser/reject/${credentials.id}`);
      if (response) {
        credentials?.dispatch(
          activeSnack({ type: 'success', message: 'Finding rejected successfully' })
        );
        return response;
      }
      return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      credentials?.dispatch(
        activeSnack({ type: 'error', message: error?.response?.data?.message })
      );
      throw error?.response?.data?.message;
    }
  }
);

// --- AUTOMATION LOG ---
export const getAutomationLogList = createAsyncThunk(
  'automation/log/list',
  async ({ credentials }) => {
    try {
      const URL = `/automation-log/admin/all?page=${credentials?.page || 1}&limit=${
        credentials?.limit || 25
      }&search=${credentials?.search || ''}&from=${credentials?.date?.from || ''}&to=${
        credentials?.date?.to || ''
      }`;

      const response = await post(URL, credentials?.state || {});
      return response;
    } catch (error) {
      credentials?.dispatch(
        activeSnack({
          type: 'error',
          message: error?.response?.data?.message || 'Failed to fetch automation logs',
        })
      );
      throw error?.response?.data?.message || 'Failed to fetch automation logs';
    }
  }
);

export const getAutomationLogSingle = createAsyncThunk(
  'automation/log/single',
  async ({ credentials }) => {
    try {
      const response = await get(`/automation-log/admin/${credentials.id}`);
      return response;
    } catch (error) {
      credentials?.dispatch(
        activeSnack({
          type: 'error',
          message: error?.response?.data?.message || 'Failed to fetch automation log',
        })
      );
      throw error?.response?.data?.message || 'Failed to fetch automation log';
    }
  }
);

// --- AUTOMATION FINDINGS ---
export const getAutomationFindingsList = createAsyncThunk(
  'automation/findings/list',
  async ({ credentials }) => {
    try {
      const URL = `/automation-findings/admin/all?page=${credentials?.page || 1}&limit=${
        credentials?.limit || 25
      }&from=${credentials?.date?.from || ''}&to=${credentials?.date?.to || ''}&search=${
        credentials?.search || ''
      }`;

      const response = await post(URL, credentials?.state || {});
      return response;
    } catch (error) {
      credentials?.dispatch(
        activeSnack({
          type: 'error',
          message: error?.response?.data?.message || 'Failed to fetch automation findings',
        })
      );
      throw error?.response?.data?.message || 'Failed to fetch automation findings';
    }
  }
);

export const getAutomationFindingsSingle = createAsyncThunk(
  'automation/findings/single',
  async ({ credentials }) => {
    try {
      const response = await get(`/automation-findings/admin/${credentials.id}`);
      return response;
    } catch (error) {
      credentials?.dispatch(
        activeSnack({
          type: 'error',
          message: error?.response?.data?.message || 'Failed to fetch automation finding',
        })
      );
      throw error?.response?.data?.message || 'Failed to fetch automation finding';
    }
  }
);

// --- EXECUTION LOG ---
export const getExecutionLogList = createAsyncThunk(
  'automation/execution-log/list',
  async ({ credentials }) => {
    try {
      const URL = `/execution-log/admin/all?page=${credentials?.page || 1}&limit=${
        credentials?.limit || 25
      }&search=${credentials?.search || ''}&from=${credentials?.date?.from || ''}&to=${
        credentials?.date?.to || ''
      }`;

      const response = await post(URL, credentials?.state || {});
      return response;
    } catch (error) {
      credentials?.dispatch(
        activeSnack({
          type: 'error',
          message: error?.response?.data?.message || 'Failed to fetch execution logs',
        })
      );
      throw error?.response?.data?.message || 'Failed to fetch execution logs';
    }
  }
);

export const getExecutionLogSingle = createAsyncThunk(
  'automation/execution-log/single',
  async ({ credentials }) => {
    try {
      const response = await get(`/execution-log/admin/${credentials.id}`);
      return response;
    } catch (error) {
      credentials?.dispatch(
        activeSnack({
          type: 'error',
          message: error?.response?.data?.message || 'Failed to fetch execution log',
        })
      );
      throw error?.response?.data?.message || 'Failed to fetch execution log';
    }
  }
);

// --- REDUX SLICE START ---
export const automationSlice = createSlice({
  name: 'automation',
  initialState: {
    loading: false,
    statusLoading: false,
    error: {},
    allAutomationList: {
      automation: [],
      total: 0,
      page: 1,
    },
    allRuleTemplateList: {
      automationRuleTemplates: [],
      total: 0,
      page: 1,
    },
    ruleTemplateDetails: {},
    ruleTemplateCreated: false,
    automationLogList: [],
    automationLogDetails: {},
    automationFindingsList: [],
    executionLogList: [],
    automationFindingsDetails: {},
    executionLogDetails: {},
    automationDetails: {},
  },
  reducers: {
    resetRuleTemplateCreated: (state) => {
      if (state.ruleTemplateCreated) {
        state.ruleTemplateCreated = false;
      }
    },
  },
  extraReducers: {
    [getAllAutomationList.pending]: (state) => {
      state.loading = true;
    },
    [getAllAutomationList.fulfilled]: (state, action) => {
      state.loading = false;
      state.allAutomationList = action.payload;
      state.error = {};
    },
    [getAllAutomationList.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [createAutomation.pending]: (state) => {
      state.loading = true;
    },
    [createAutomation.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = {};
    },
    [createAutomation.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // get automation details
    [getAutomationDetails.pending]: (state) => {
      state.loading = true;
    },
    [getAutomationDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.automationDetails = action.payload;
      state.error = {};
    },
    [getAutomationDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // update automation status
    [updateAutomationStatus.pending]: (state) => {
      state.statusLoading = true;
    },
    [updateAutomationStatus.fulfilled]: (state, action) => {
      state.statusLoading = false;
      state.allAutomationList = {
        ...state.allAutomationList,
        automation: state.allAutomationList.automation.map((automation) =>
          automation._id === action.payload._id ? action.payload : automation
        ),
      };
      state.error = {};
    },
    [updateAutomationStatus.rejected]: (state, action) => {
      state.statusLoading = false;
      state.error = action.error;
    },

    // update automation
    [updateAutomation.pending]: (state) => {
      state.loading = true;
    },
    [updateAutomation.fulfilled]: (state, action) => {
      state.loading = false;
      state.automationDetails = action.payload;
      state.error = {};
    },
    [updateAutomation.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // rule template

    [getAllRuleTemplateList.pending]: (state) => {
      state.loading = true;
    },
    [getAllRuleTemplateList.fulfilled]: (state, action) => {
      state.loading = false;
      state.allRuleTemplateList = action.payload;
      state.error = {};
    },
    [getAllRuleTemplateList.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // create rule template
    [createRuleTemplate.pending]: (state) => {
      state.loading = true;
    },
    [createRuleTemplate.fulfilled]: (state, action) => {
      state.loading = false;
      state.ruleTemplateCreated = true;
      state.error = {};
      // Add the new rule template to the list
      if (action.payload && action.payload._id) {
        state.allRuleTemplateList = {
          ...state.allRuleTemplateList,
          automationRuleTemplates: [
            action.payload,
            ...(state.allRuleTemplateList.automationRuleTemplates || []),
          ],
          total: (state.allRuleTemplateList.total || 0) + 1,
        };
      }
    },
    [createRuleTemplate.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // get rule template by id
    [getRuleTemplateDetails.pending]: (state) => {
      state.loading = true;
    },
    [getRuleTemplateDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.ruleTemplateDetails = action.payload;
      state.error = {};
    },
    [getRuleTemplateDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // update rule template
    [updateRuleTemplate.pending]: (state) => {
      state.loading = true;
    },
    [updateRuleTemplate.fulfilled]: (state, action) => {
      state.loading = false;
      state.ruleTemplateDetails = action.payload;
      state.error = {};
    },
    [updateRuleTemplate.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // update rule template status
    [updateRuleTemplateStatus.pending]: (state) => {
      state.statusLoading = true;
    },
    [updateRuleTemplateStatus.fulfilled]: (state, action) => {
      state.statusLoading = false;
      state.allRuleTemplateList = {
        ...state.allRuleTemplateList,
        automationRuleTemplates: state.allRuleTemplateList.automationRuleTemplates.map(
          (template) => (template._id === action.payload._id ? action.payload : template)
        ),
      };
      state.error = {};
    },
    [updateRuleTemplateStatus.rejected]: (state, action) => {
      state.statusLoading = false;
      state.error = action.error;
    },

    // automation log
    [getAutomationLogList.pending]: (state) => {
      state.loading = true;
    },
    [getAutomationLogList.fulfilled]: (state, action) => {
      state.loading = false;
      state.automationLogList = action.payload;
      state.error = {};
    },
    [getAutomationLogList.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // automation log single
    [getAutomationLogSingle.pending]: (state) => {
      state.loading = true;
    },
    [getAutomationLogSingle.fulfilled]: (state, action) => {
      state.loading = false;
      state.automationLogDetails = action.payload;
      state.error = {};
    },
    [getAutomationLogSingle.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // automation findings
    [getAutomationFindingsList.pending]: (state) => {
      state.loading = true;
    },
    [getAutomationFindingsList.fulfilled]: (state, action) => {
      state.loading = false;
      state.automationFindingsList = action.payload;
      state.error = {};
    },
    [getAutomationFindingsList.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // automation findings single
    [getAutomationFindingsSingle.pending]: (state) => {
      state.singleViewLoading = true;
    },
    [getAutomationFindingsSingle.fulfilled]: (state, action) => {
      state.singleViewLoading = false;
      state.automationFindingsDetails = action.payload;
      state.error = {};
    },
    [getAutomationFindingsSingle.rejected]: (state, action) => {
      state.singleViewLoading = false;
      state.error = action.error;
    },

    // execution log
    [getExecutionLogList.pending]: (state) => {
      state.loading = true;
    },
    [getExecutionLogList.fulfilled]: (state, action) => {
      state.loading = false;
      state.executionLogList = action.payload;
      state.error = {};
    },
    [getExecutionLogList.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // execution log single
    [getExecutionLogSingle.pending]: (state) => {
      state.loading = true;
    },
    [getExecutionLogSingle.fulfilled]: (state, action) => {
      state.loading = false;
      state.executionLogDetails = action.payload;
      state.error = {};
    },
    [getExecutionLogSingle.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // execute the finding
    [executeAutomationFindings.pending]: (state) => {
      state.loading = true;
    },
    [executeAutomationFindings.fulfilled]: (state, action) => {
      state.loading = false;
      state.automationFindingsDetails = action.payload;
      state.error = {};
    },
    [executeAutomationFindings.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // reject the finding
    [rejectAutomationFindings.pending]: (state) => {
      state.loading = true;
    },
    [rejectAutomationFindings.fulfilled]: (state, action) => {
      state.loading = false;
      state.automationFindingsDetails = action.payload;
      state.error = {};
    },
    [rejectAutomationFindings.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // execute the finding (advertiser)
    [executeAutomationFindingsAdvertiser.pending]: (state) => {
      state.loading = true;
    },
    [executeAutomationFindingsAdvertiser.fulfilled]: (state, action) => {
      state.loading = false;
      state.automationFindingsDetails = action.payload;
      state.error = {};
    },
    [executeAutomationFindingsAdvertiser.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // reject the finding (advertiser)
    [rejectAutomationFindingsAdvertiser.pending]: (state) => {
      state.loading = true;
    },
    [rejectAutomationFindingsAdvertiser.fulfilled]: (state, action) => {
      state.loading = false;
      state.automationFindingsDetails = action.payload;
      state.error = {};
    },
    [rejectAutomationFindingsAdvertiser.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});

export const { resetRuleTemplateCreated } = automationSlice.actions;

export default automationSlice.reducer;
